import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Bundlers break Leaflet's default marker icon paths; this is the standard fix.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

const ownerIcon = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  className: 'owner-marker'
});

// Free, no-API-key map (OpenStreetMap tiles via Leaflet) showing the owner's
// location and every walker returned by search.
const WalkerMap = ({ ownerLocation, walkers, onSelectWalker }) => {
  if (!ownerLocation) return null;

  return (
    <div className="walker-map">
      <MapContainer
        center={[ownerLocation.latitude, ownerLocation.longitude]}
        zoom={13}
        style={{ height: '320px', width: '100%', borderRadius: '8px' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[ownerLocation.latitude, ownerLocation.longitude]} icon={ownerIcon}>
          <Popup>You are here</Popup>
        </Marker>
        {walkers.map(walker => (
          walker.latitude && walker.longitude ? (
            <Marker key={walker.id} position={[walker.latitude, walker.longitude]}>
              <Popup>
                <strong>{walker.first_name} {walker.last_name}</strong><br />
                {walker.distance_miles} miles away<br />
                £{Number(walker.rate_per_walk_gbp || 12).toFixed(2)} / 30 min
                {onSelectWalker && (
                  <>
                    <br />
                    <button onClick={() => onSelectWalker(walker)}>Book</button>
                  </>
                )}
              </Popup>
            </Marker>
          ) : null
        ))}
      </MapContainer>
    </div>
  );
};

export default WalkerMap;
